import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import RowClick from '../../../common/RowClick';
import Table from '../../../common/table/Table';
import TextBlink from '../../../common/table/TextBlink';
import {
  candleStickCalculation,
  DOWN,
  UP,
} from '../../../helpers/CandleStickCalculation';
import { getColorPrice } from '../../../helpers/Color';
import { getDataFollowKeyByDot, getSMA } from '../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../helpers/Text';
import CellHover from '../../../market/watchlist/summary/CellHover';
import { getSortStateParams } from '../helper';
import {
  REDUCER_NAME,
  loadMoreData,
  changeSortState,
  getScreenerData,
} from '../reducer';
import TradingViewUrl from '../../../common/TradingViewUrl';
import Const from './Const';

class TableTechnical extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 30,
    };
    this.tableRef = React.createRef();
  }

  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectScreenerDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  candleStickCal = (item, listColumn) => {
    return candleStickCalculation(
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      getDataFollowKeyByDot(item, listColumn.OPEN_PRICE),
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.H1),
      getDataFollowKeyByDot(item, listColumn.L1),
      getDataFollowKeyByDot(item, listColumn.O1),
      getDataFollowKeyByDot(item, listColumn.C1),
      getDataFollowKeyByDot(item, listColumn.H2),
      getDataFollowKeyByDot(item, listColumn.L2),
      getDataFollowKeyByDot(item, listColumn.O2),
      getDataFollowKeyByDot(item, listColumn.C2),
      getDataFollowKeyByDot(item, listColumn.SMA20),
      getDataFollowKeyByDot(item, listColumn.SMA20Past4),
    );
  };

  getTrend = trend => {
    if (trend === DOWN) {
      return <i className="icon-down fs-12 text-s-color-3" />;
    } else if (trend === UP) {
      return <i className="icon-up fs-12 text-s-color-5" />;
    }
  };

  handleScroll = e => {
    const { totalPage, loadMoreData, page, isLoading } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page === totalPage || isLoading) return;

    if (bottom) {
      const newpage = page + 1;
      loadMoreData(newpage);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.page === 1) {
      this.resetScroll();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState, getScreenerData } = this.props;
    if (sortState !== prevProps.sortState) {
      getScreenerData(getSortStateParams(sortState));
    }
  }

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  schema = (listColumn, i18nTitleKey) => {
    return Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;
      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          render: (text, item) => {
            return (
              <CellHover
                organCode={item.stockScreenerItem.organCode}
                isShowDeleteIcon={false}
              >
                <TextBlink item={item} tradingDate="tradingDate">
                  <TradingViewUrl code={item.stockScreenerItem.organCode} />
                  &nbsp;{text}
                </TextBlink>
              </CellHover>
            );
          },
        };
      }

      if (_.includes([listColumn.VOLUME], key)) {
        return {
          ...result,
          render: (text, item) => {
            const price = getDataFollowKeyByDot(item, listColumn.PRICE);
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {price === 0 ? '--' : formatVolume(text)}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes([listColumn.SMA20, listColumn.SMA50, listColumn.SMA100], key)
      ) {
        return {
          ...result,
          render: (text, item) => {
            const value = getSMA(
              text,
              getDataFollowKeyByDot(item, 'priceInfo.matchPrice'),
            );
            return (
              <div className={`${value} pl-8 pr-8`}>
                {I18n.t(`common.${value}`)}
              </div>
            );
          },
        };
      }

      if (_.includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text), 2, true)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.PERCENT_PRICE_CHANGE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const price = getDataFollowKeyByDot(item, listColumn.PRICE);
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {price === 0 ? '--' : `${formatTextFloat(text * 100)}%`}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RSI], key)) {
        return {
          ...result,
          render: text => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(text)}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes([listColumn.SMA20, listColumn.SMA50, listColumn.SMA100], key)
      ) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.CANDLE_STICK], key)) {
        return {
          disableSort: true,
          ...result,
          thStyle: { textAlign: 'left' },
          render: (text, item) => {
            const candleStickData = this.candleStickCal(item, listColumn);
            const trend = this.getTrend(candleStickData.trend);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className="text-left"
              >
                {candleStickData.candleStick} {trend}
              </TextBlink>
            );
          },
        };
      }

      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text, 0)}
          </TextBlink>
        ),
      };
    });
  };

  render() {
    const { ids, isLoading, changeSortState, sortState } = this.props;
    return (
      <RowClick>
        {onRowClick => (
          <Table
            clickRow={onRowClick}
            onSort={changeSortState}
            sortState={sortState}
            scrollRef={this.tableRef}
            isLoading={isLoading}
            ids={ids}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            schema={this.schema(
              Const.listColumn,
              'topBreakout.technical.technicalHeader',
            )}
          />
        )}
      </RowClick>
    );
  }
}
const mapStateToProps = state => {
  return {
    ids: state[REDUCER_NAME].listScreenerDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    page: state[REDUCER_NAME].page,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
  loadMoreData,
  getScreenerData,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TableTechnical);
